import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ScrollToTop } from "@/components/ScrollToTop";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import CustomerDashboard from "@/pages/CustomerDashboard";
import ProviderDashboard from "@/pages/ProviderDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import OrderDetail from "@/pages/OrderDetail";
import Providers from "@/pages/Providers";
import ProviderProfile from "@/pages/ProviderProfile";
import CityLanding from "@/pages/CityLanding";
import HowItWorks from "@/pages/HowItWorks";
import PricingPage from "@/pages/PricingPage";
import ForProviders from "@/pages/ForProviders";
import AirbnbModule from "@/pages/AirbnbModule";
import Apartments from "@/pages/Apartments";
import ProviderVerification from "@/pages/ProviderVerification";
import DisputeDetail from "@/pages/DisputeDetail";
import ForgotPassword from "@/pages/ForgotPassword";
import AdminUserDetail from "@/pages/AdminUserDetail";
import Contact from "@/pages/Contact";

/**
 * NOTE: All public SEO landing pages (homepage, /prani-pradla-{mesto},
 * /pro-pradleny, /sluzby/{sluzba}, /jak-to-funguje, /cenik, /kontakt,
 * /sitemap.xml, /robots.txt) are served by the Next.js app at /app/web
 * (SSR/SSG/ISR). This CRA app handles only authenticated dashboards and
 * legacy app routes. In preview, src/setupProxy.js forwards SEO paths
 * to the Next.js server on port 3001.
 */

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/prihlaseni" element={<Login />} />
            <Route path="/zapomenute-heslo" element={<ForgotPassword />} />
            <Route path="/registrace" element={<Register />} />
            <Route path="/jak-to-funguje" element={<HowItWorks />} />
            <Route path="/cenik" element={<PricingPage />} />
            <Route path="/pradelny" element={<Providers />} />
            <Route path="/pradelna/:id" element={<ProviderProfile />} />
            <Route path="/pro-pradelny" element={<ForProviders />} />
            <Route path="/airbnb" element={<AirbnbModule />} />
            <Route path="/prani-pradla/:slug" element={<CityLanding />} />
            <Route path="/kontakt" element={<Contact />} />

            <Route path="/dashboard/customer" element={
              <ProtectedRoute roles={["customer"]}><CustomerDashboard /></ProtectedRoute>
            } />
            <Route path="/dashboard/provider" element={
              <ProtectedRoute roles={["provider"]}><ProviderDashboard /></ProtectedRoute>
            } />
            <Route path="/dashboard/provider/verifikace" element={
              <ProtectedRoute roles={["provider"]}><ProviderVerification /></ProtectedRoute>
            } />
            <Route path="/apartmany" element={
              <ProtectedRoute roles={["customer"]}><Apartments /></ProtectedRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>
            } />
            <Route path="/admin/uzivatel/:id" element={
              <ProtectedRoute roles={["admin"]}><AdminUserDetail /></ProtectedRoute>
            } />
            <Route path="/order/:id" element={
              <ProtectedRoute><OrderDetail /></ProtectedRoute>
            } />
            <Route path="/dispute/:id" element={
              <ProtectedRoute><DisputeDetail /></ProtectedRoute>
            } />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
